<template>
  <div>
    <align class="header" flex>
      <div class="title-block">
        <h3 class="secondary-font">
          Monthly Volume
        </h3>

        <p class="description">
          The total amount of money spent on cards and sealed wax each month. Note this does NOT include memorabilia, tickets, etc.
        </p>
      </div>

      <icon-link @click.native="viewIndustry">
        View More
      </icon-link>
    </align>

    <graph-overview
      graph-only
      month-labels
      :graph-values="[monthlyVolumeTotal]"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import moment from 'moment';

import GraphOverview from '@cardladder/shared/components/GraphOverview';
import {
  monthlyVolumeTotalKeyToGraphLabel,
  volumeGraphPointColorForLabel,
} from '@cardladder/shared/utils/graphs.util';

export default {
  components: {
    GraphOverview,
  },

  props: {
    data: Object,
  },

  computed: {
    monthlyVolumeTotal() {
      if (!this.data || !this.data.monthlyVolumeTotal) {
        return {};
      }

      const data = {};
      const pointColors = {};
      const currentMonthLabel = moment().format('MM/01/YYYY');

      Object.keys(this.data.monthlyVolumeTotal).forEach((monthKey) => {
        const monthVolume = this.data.monthlyVolumeTotal[monthKey];
        const total = monthVolume != null ? Number(monthVolume.total) : NaN;
        const graphKey = monthlyVolumeTotalKeyToGraphLabel(monthKey);

        if (!graphKey || !Number.isFinite(total) || graphKey === currentMonthLabel) {
          return;
        }

        data[graphKey] = total;
        pointColors[graphKey] = volumeGraphPointColorForLabel(graphKey);
      });

      return {
        label: 'Monthly Volume',
        data,
        pointColors,
      };
    },
  },

  methods: {
    viewIndustry() {
      this.$router.push('/industry');
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin: 0 0 $gp;
  align-items: flex-start;
}

.title-block {
  flex: 1;
  min-width: 0;
  padding-right: $gp;
}

h3 {
  margin: 0;
}

p.description {
  margin: $gp * .25 0 0;
  color: $color-gray-4;
  font-style: italic;
  font-family: $font-family-secondary;
}
</style>
